export default __webpack_public_path__ + "assets/unswg_KeyDates_aem.csv?cfa92920a9bc818c8e4f9efecb5ee155";